import React, { useEffect, useLayoutEffect, useState } from "react";
import MainContainer from "../../layout/MainContainer";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import DeleteIcon from "@mui/icons-material/Delete";

import FileDownloadIcon from "@mui/icons-material/FileDownload";
import {
  Card,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Box,
  Switch,
  Button,
  Typography,
  Tabs,
  Tab,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";

import SearchBar2 from "../../components/SearchBar2";
import { isValidInput } from "../../utils/validation";

import { errorToast, successToast } from "../../helpers/toast";
import Pagination from "../../components/Pagination";
import WarnModal from "../../components/WarnModal";
import Loader from "../../helpers/constants/Loader";
import moment from "moment";
import {
  useDeleteVendorMutation,
  useGetAllCountMutation,
  useLazyGetVendorListQuery,
  useLazyPostVendorCsvQuery,
  usePutChangeUserStatusMutation,
  useUpdateVendorApprovalStatusMutation,
} from "../../services/registration";
import RejectModal from "../../components/RejectModal";
import useTranslation from "../../hooks/Translation";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ManageAgents = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const t = useTranslation();
  const [getAllCount] = useGetAllCountMutation();
  const [vendorApprovalStatus] = useUpdateVendorApprovalStatusMutation();

  const [total_records, settotal_records] = useState<number>(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(1);
  const [totalCount, setTotalCount1] = useState<number>(0);
  const [limit, setLimit] = useState<number>(10);
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [open, setOpen] = useState(false);
  const [selectedId, setSelectedId] = useState<any>(0);

  const [rejectOpen, setRejectOpen] = useState(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [deleteUserById] = useDeleteVendorMutation();
  const [putChangeUserStatus] = usePutChangeUserStatusMutation();
  const [month, setMonth] = useState(new Date());
  const [value, setValue] = React.useState(0);
  const [getallusers] = useLazyGetVendorListQuery();
  const [rows, setRows] = useState<any>([]);
  const [totalPages, setTotalPages] = useState(1);
  const [vendorCount, setVendorCount] = useState<any>(0);
  const [vendorCsv] = useLazyPostVendorCsvQuery();
  const [range, setRange] = useState<{
    from: Date | undefined;
    to: Date | undefined;
  }>({
    from: undefined,
    to: undefined,
  });
  const postVendorCsv = async () => {
    try {
      const response = await vendorCsv({}).unwrap();
      if (response?.status === 200) {
        window?.open(response?.file_urls);
      } else {
        console.log("error");
      }
    } catch (error: any) {}
  };
  const changeUserStatus = async (id: string, is_active: boolean) => {
    try {
      const body = { is_active };

      const response = await putChangeUserStatus({
        id,
        is_active: !is_active,
      }).unwrap();
      if (response?.status === 200) {
        if (is_active === false) {
          successToast("Vendor Activated Successfully");
        } else {
          successToast("Vendor Deactivated Successfully");
        }
        fetchData(page, searchTerm);
      }
    } catch (error: any) {
      console.error("Error updating status:", error);
    }
  };

  const fetchData = async (page: number, search: string) => {
    setIsLoading(true);
    try {
      const response = await getallusers({
        body: {
          start: page,
          search: search,
          length: limit,
          status: value + 1,
        },
      }).unwrap();

      if (response.status === 200) {
        setIsLoading(false);

        // Validate and set rows
        const users = Array.isArray(response?.data?.response_object)
          ? response.data.response_object
          : [];
        setRows(users);

        // Update total records based on status
        settotal_records(response?.data?.total_records);
        setTotalPages(Math.ceil(response?.data?.total_records / 10));
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Error fetching user data:", error);
    }
  };

  const handleDeleteUser = async (userId: string) => {
    setIsLoading(true);
    try {
      const response = await deleteUserById({
        id: userId,
        profile_status: "3",
      }).unwrap();
      if (response?.status === 200) {
        successToast("Vendor deleted successfully");
        fetchData(page, searchTerm);
      }
    } catch (error: any) {
      console.error(error);
      errorToast(error?.message || "Failed to delete user");
    } finally {
      setIsLoading(false);
    }
  };

  const ApproveReject = async (id: any, approvalStatus: any) => {
    setIsLoading(true);
    try {
      const response = await vendorApprovalStatus({
        id,
        profile_status: approvalStatus,
      }).unwrap();
      if (response.status === 200) {
        if (approvalStatus === 4) {
          successToast("Vendor Rejected Successfully");
        } else if (approvalStatus === 5) {
          successToast("Vendor Accepted Successfully");
        }
        fetchData(page, searchTerm);
        FetchAllCount();
      } else {
      }
    } catch (error: any) {
      console.error("Error updating approval status:", error);
      errorToast(error?.message || "Failed to update approval status");
    } finally {
      setIsLoading(false);
    }
  };

  const FetchAllCount = async () => {
    setIsLoading(true);
    let body = {
      user_role: 4,
      search: debouncedSearchTerm,
    };
    try {
      const response = await getAllCount(body).unwrap();

      if (response.status === 200) {
        setVendorCount(response?.data);
      }
    } catch (error) {
      setIsLoading(false);
      console.error(error);
    }
  };

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    setPage(1);
  };

  useEffect(() => {
    if (state) {
      setValue(state?.value);
    }
  }, []);

  useEffect(() => {
    fetchData(page, debouncedSearchTerm);
  }, [page, debouncedSearchTerm, limit, range, value]);

  useEffect(() => {
    FetchAllCount();
  }, [debouncedSearchTerm]);

  return (
    <div>
      <Loader isLoad={isLoading} />
      <div className="main_loyout">
        <div className="dashboard">
          <h1 className="mn_hdng">{t.sideBar.manageVendors}</h1>
        </div>
        <Card className="cards">
          <Box className="cards_header" marginBottom={"20px"}>
            <Box className="cards_header_left">
              <SearchBar2
                value={searchTerm}
                searchTerm={searchTerm}
                onCross={() => setSearchTerm("")}
                setDebouncedSearchTerm={setDebouncedSearchTerm}
                onChange={(val: any) => {
                  if (isValidInput(val.target.value)) {
                    setSearchTerm(val.target.value);
                  }
                }}
              />
            </Box>

            <Box className="cards_header_right">
              <Button
                className="btn btn_primary"
                onClick={postVendorCsv}
                disabled={rows?.length === 0 ? true : false}
              >
                <FileDownloadIcon /> {t.main.exportCsv}
              </Button>
            </Box>
          </Box>
          <Box className="custom_tabs">
            <Tabs
              value={value}
              onChange={handleChange}
              variant="scrollable"
              scrollButtons="auto"
              aria-label="basic tabs example"
              className="custom_tabs_links"
            >
              <Tab
                label={`${t.main.pending}${vendorCount?.pending ? ` (${vendorCount?.pending})` : ""}`}
                {...a11yProps(0)}
              />
              <Tab
                label={`${t.main.approved}${vendorCount?.activate ? ` (${vendorCount?.activate})` : ""}`}
                {...a11yProps(1)}
              />
              <Tab
                label={`${t.main.rejected}${vendorCount?.rejected ? ` (${vendorCount?.rejected})` : ""}`}
                {...a11yProps(2)}
              />
              <Tab
                label={`${t.main.deactivate}${vendorCount?.deactivate ? ` (${vendorCount?.deactivate})` : ""}`}
                {...a11yProps(3)}
              />
            </Tabs>

            <CustomTabPanel value={value} index={0}>
              <TableContainer className="table_container">
                <Box className="heading"></Box>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell align="center">S.No</TableCell>
                      {/* <TableCell>User Id</TableCell> */}
                      <TableCell>{t.main.image}</TableCell>
                      <TableCell>{t.main.fullName}</TableCell>
                      <TableCell>{t.main.phoneNumber}</TableCell>
                      <TableCell>{t.main.email}</TableCell>
                      <TableCell>{t.main.businessName}</TableCell>

                      <TableCell>{t.main.industryType}</TableCell>
                      <TableCell>{t.main.address}</TableCell>
                      <TableCell>{t.main.manageAccount}</TableCell>
                      <TableCell>{t.main.accountStatus}</TableCell>
                      <TableCell>{t.main.actions}</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows?.length == 0 ? (
                      <TableRow>
                        <TableCell colSpan={11} align="center">
                          {t.error.noVendorFound}
                        </TableCell>
                      </TableRow>
                    ) : (
                      rows?.map((row: any, i: any) => (
                        <TableRow key={row?.id}>
                          <TableCell align="center">
                            {(page - 1) * 10 + i + 1}
                          </TableCell>

                          <TableCell>
                            <figure
                              onClick={() =>
                                navigate(`/manage-vendors/details/${row?.id}`, {
                                  state: { value },
                                })
                              }
                              className="user_img"
                            >
                              <img
                                src={
                                  row?.profile_picture?.media_url ||
                                  "/static/images/user_placeholder.png"
                                }
                                alt=""
                              />
                            </figure>
                          </TableCell>

                          <TableCell>{row?.full_name || "-"}</TableCell>

                          <TableCell>
                            {row?.country_code + ` ` + row?.phone_no || "-"}
                          </TableCell>
                          <TableCell>{row?.email || "-"}</TableCell>
                          <TableCell>{row?.business_name || "-"}</TableCell>

                          <TableCell>
                            {row?.industry_type === 1
                              ? "RETAILER"
                              : row?.industry_type === 2
                                ? "WHOLESALER"
                                : row?.industry_type === 3
                                  ? "DISTRIBUTER"
                                  : ""}
                          </TableCell>
                          <TableCell>
                            {row?.address?.business_address || "-"}
                          </TableCell>
                          <TableCell>
                            {
                              <div
                                style={{
                                  justifyContent: "space-between",
                                  display: "flex",
                                }}
                              >
                                <Button
                                  value="Reject"
                                  onClick={() => {
                                    setRejectOpen(true);
                                    setSelectedId(row?.id);
                                    // ApproveReject(row?.id, 3);
                                  }}
                                  style={{
                                    backgroundColor: "red",
                                    width: 90,
                                    height: 40,
                                    color: "white",
                                  }}
                                >
                                  {t.main.reject}
                                </Button>
                                <div style={{ margin: 8 }}></div>
                                <Button
                                  value="Approve"
                                  style={{
                                    backgroundColor: "green",
                                    width: 90,
                                    height: 40,
                                    color: "white",
                                  }}
                                  onClick={() => ApproveReject(row?.id, 5)}
                                >
                                  {t.main.accept}
                                </Button>
                              </div>
                            }
                          </TableCell>
                          <TableCell>
                            <Switch
                              defaultChecked={row.is_active}
                              onChange={(e) => {
                                const isChecked = !e.target.checked;
                                changeUserStatus(row?.id, isChecked);
                              }}
                              size="small"
                            />
                          </TableCell>
                          <TableCell>
                            <Box className="table_actions">
                              <IconButton
                                onClick={() =>
                                  navigate(
                                    `/manage-vendors/details/${row?.id}`,
                                    { state: { value } }
                                  )
                                }
                              >
                                <VisibilityIcon />
                              </IconButton>
                              <IconButton
                                onClick={() =>
                                  navigate(`/manage-vendors/edit/${row?.id}`)
                                }
                              >
                                <ModeEditIcon />
                              </IconButton>
                              <IconButton
                                onClick={() => {
                                  setOpen(true);
                                  setSelectedId(row?.id);
                                }}
                              >
                                <DeleteIcon />
                              </IconButton>
                            </Box>
                          </TableCell>
                        </TableRow>
                      ))
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              {/* {rows?.length > 0 ? (
                <Pagination
                  setPage={setPage}
                  module={rows}
                  page={page}
                  onPageChange={onPageChange}
                  totalPages={1}
                  limit={limit}
                  setLimit={setLimit}
                />
              ) : (
                ""
              )} */}
              <RejectModal
                open={rejectOpen}
                setOpen={setRejectOpen}
                handleDelete={() => {
                  ApproveReject(selectedId, 4);
                }}
                name="Vendor"
              />
              <WarnModal
                open={open}
                setOpen={setOpen}
                handleDelete={() => handleDeleteUser(selectedId)}
                name="Vendor"
              />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
              <TableContainer className="table_container">
                <Box className="heading"></Box>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell align="center">S.No</TableCell>
                      {/* <TableCell>User Id</TableCell> */}
                      <TableCell>{t.main.image}</TableCell>
                      <TableCell>{t.main.fullName}</TableCell>
                      <TableCell>{t.main.phoneNumber}</TableCell>
                      <TableCell>{t.main.email}</TableCell>
                      <TableCell>{t.main.businessName}</TableCell>

                      <TableCell>{t.main.industryType}</TableCell>
                      <TableCell>{t.main.address}</TableCell>
                      <TableCell>{t.main.manageAccount}</TableCell>
                      <TableCell>{t.main.accountStatus}</TableCell>
                      <TableCell>{t.main.actions}</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows?.length == 0 ? (
                      <TableRow>
                        <TableCell colSpan={9} align="center">
                          {t.error.noVendorFound}
                        </TableCell>
                      </TableRow>
                    ) : (
                      rows?.map((row: any, i: any) => (
                        <TableRow key={row?.name}>
                          <TableCell align="center">
                            {(page - 1) * 10 + i + 1}
                          </TableCell>
                          {/* <TableCell>{row?.referenceId || "-"}</TableCell> */}
                          <TableCell>
                            <figure
                              onClick={() =>
                                navigate(`/manage-vendors/details/${row?.id}`, {
                                  state: { value },
                                })
                              }
                              className="user_img"
                            >
                              <img
                                src={
                                  row?.profile_picture?.media_url ||
                                  "/static/images/user_placeholder.png"
                                }
                                alt=""
                              />
                            </figure>
                          </TableCell>
                          <TableCell>{row?.full_name || "-"}</TableCell>

                          <TableCell>
                            {row?.country_code + ` ` + row?.phone_no || "-"}
                          </TableCell>
                          <TableCell>{row?.email || "-"}</TableCell>
                          <TableCell>{row?.business_name || "-"}</TableCell>

                          <TableCell>
                            {row?.industry_type === 1
                              ? "RETAILER"
                              : row?.industry_type === 2
                                ? "WHOLESALER"
                                : row?.industry_type === 3
                                  ? "DISTRIBUTER"
                                  : ""}
                          </TableCell>
                          <TableCell>
                            {row?.address?.business_address || "-"}
                          </TableCell>
                          <TableCell>
                            {
                              <div
                                style={{
                                  alignItems: "center",
                                }}
                              >
                                <Button
                                  value="Reject"
                                  onClick={() => {
                                    setRejectOpen(true);
                                    setSelectedId(row?.id);
                                  }}
                                  style={{
                                    backgroundColor: "red",
                                    width: 90,
                                    height: 40,
                                    color: "white",
                                  }}
                                >
                                  {t.main.reject}
                                </Button>
                              </div>
                            }
                          </TableCell>
                          <TableCell>
                            <Switch
                              defaultChecked={row.is_active}
                              onChange={(e) => {
                                const isChecked = !e.target.checked;
                                changeUserStatus(row?.id, isChecked);
                              }}
                              size="small"
                            />
                          </TableCell>
                          <TableCell>
                            <Box className="table_actions">
                              <IconButton
                                onClick={() =>
                                  navigate(
                                    `/manage-vendors/details/${row?.id}`,
                                    { state: { value } }
                                  )
                                }
                              >
                                <VisibilityIcon />
                              </IconButton>
                              <IconButton
                                onClick={() =>
                                  navigate(`/manage-vendors/edit/${row?.id}`)
                                }
                              >
                                <ModeEditIcon />
                              </IconButton>
                              <IconButton
                                onClick={() => {
                                  setOpen(true);
                                  setSelectedId(row?.id);
                                }}
                              >
                                <DeleteIcon />
                              </IconButton>
                            </Box>
                          </TableCell>
                        </TableRow>
                      ))
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              {/* {rows?.length > 0 ? (
                <Pagination
                  setPage={setPage}
                  module={rows}
                  page={page}
                  onPageChange={onPageChange}
                  totalPages={1}
                  limit={limit}
                  setLimit={setLimit}
                />
              ) : (
                ""
              )} */}
              <RejectModal
                open={rejectOpen}
                setOpen={setRejectOpen}
                handleDelete={() => {
                  ApproveReject(selectedId, 4);
                }}
                name="Vendor"
              />
              <WarnModal
                open={open}
                setOpen={setOpen}
                handleDelete={() => handleDeleteUser(selectedId)}
                name="Vendor"
              />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={2}>
              <TableContainer className="table_container">
                <Box className="heading"></Box>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell align="center">S.No</TableCell>
                      <TableCell>{t.main.image}</TableCell>
                      <TableCell>{t.main.fullName}</TableCell>
                      <TableCell>{t.main.phoneNumber}</TableCell>
                      <TableCell>{t.main.email}</TableCell>
                      <TableCell>{t.main.businessName}</TableCell>
                      <TableCell>{t.main.industryType}</TableCell>
                      <TableCell>{t.main.address}</TableCell>
                      <TableCell>{t.main.manageAccount}</TableCell>

                      <TableCell>{t.main.actions}</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows?.length == 0 ? (
                      <TableRow>
                        <TableCell colSpan={9} align="center">
                          {t.error.noVendorFound}
                        </TableCell>
                      </TableRow>
                    ) : (
                      rows?.map((row: any, i: any) => (
                        <TableRow key={row?.id}>
                          <TableCell align="center">
                            {(page - 1) * 10 + i + 1}
                          </TableCell>
                          {/* <TableCell>{row?.referenceId || "-"}</TableCell> */}
                          <TableCell>
                            <figure
                              onClick={() =>
                                navigate(`/manage-vendors/details/${row?.id}`, {
                                  state: { value },
                                })
                              }
                              className="user_img"
                            >
                              <img
                                src={
                                  row?.profile_picture?.media_url ||
                                  "/static/images/user_placeholder.png"
                                }
                                alt=""
                              />
                            </figure>
                          </TableCell>
                          <TableCell>{row?.full_name || "-"}</TableCell>

                          <TableCell>
                            {row?.country_code + ` ` + row?.phone_no || "-"}
                          </TableCell>
                          <TableCell>{row?.email || "-"}</TableCell>
                          <TableCell>{row?.business_name || "-"}</TableCell>

                          <TableCell>
                            {row?.industry_type === 1
                              ? "RETAILER"
                              : row?.industry_type === 2
                                ? "WHOLESALER"
                                : row?.industry_type === 3
                                  ? "DISTRIBUTER"
                                  : ""}
                          </TableCell>
                          <TableCell>
                            {row?.address?.business_address || "-"}
                          </TableCell>
                          <TableCell>
                            {
                              <div
                                style={{
                                  alignItems: "center",
                                }}
                              >
                                <Button
                                  value="Approve"
                                  style={{
                                    backgroundColor: "green",
                                    width: 90,
                                    height: 40,
                                    color: "white",
                                  }}
                                  onClick={() => ApproveReject(row?.id, 5)}
                                >
                                  {t.main.accept}
                                </Button>
                              </div>
                            }
                          </TableCell>

                          <TableCell>
                            <Box className="table_actions">
                              <IconButton
                                onClick={() =>
                                  navigate(
                                    `/manage-vendors/details/${row?.id}`,
                                    { state: { value } }
                                  )
                                }
                              >
                                <VisibilityIcon />
                              </IconButton>
                              <IconButton
                                onClick={() =>
                                  navigate(`/manage-vendors/edit/${row?.id}`)
                                }
                              >
                                <ModeEditIcon />
                              </IconButton>
                              <IconButton
                                onClick={() => {
                                  setOpen(true);
                                  setSelectedId(row?.id);
                                }}
                              >
                                <DeleteIcon />
                              </IconButton>
                            </Box>
                          </TableCell>
                        </TableRow>
                      ))
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              {/* {rows?.length > 0 ? (
                <Pagination
                  setPage={setPage}
                  module={rows}
                  page={page}
                  onPageChange={onPageChange}
                  totalPages={1}
                  limit={limit}
                  setLimit={setLimit}
                />
              ) : (
                ""
              )} */}
              <WarnModal
                open={open}
                setOpen={setOpen}
                handleDelete={() => handleDeleteUser(selectedId)}
                name="Vendor"
              />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={3}>
              <TableContainer className="table_container">
                <Box className="heading"></Box>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell align="center">S.No</TableCell>
                      <TableCell>{t.main.image}</TableCell>
                      <TableCell>{t.main.fullName}</TableCell>
                      <TableCell>{t.main.phoneNumber}</TableCell>
                      <TableCell>{t.main.email}</TableCell>
                      <TableCell>{t.main.businessName}</TableCell>
                      <TableCell>{t.main.industryType}</TableCell>
                      <TableCell>{t.main.address}</TableCell>
                      <TableCell>{t.main.address}</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows?.length == 0 ? (
                      <TableRow>
                        <TableCell colSpan={9} align="center">
                          No vendor found
                        </TableCell>
                      </TableRow>
                    ) : (
                      rows?.map((row: any, i: any) => (
                        <TableRow key={row?.id}>
                          <TableCell align="center">
                            {(page - 1) * 10 + i + 1}
                          </TableCell>
                          {/* <TableCell>{row?.referenceId || "-"}</TableCell> */}
                          <TableCell>
                            <figure
                              onClick={() =>
                                navigate(`/manage-vendors/details/${row?.id}`, {
                                  state: { value },
                                })
                              }
                              className="user_img"
                            >
                              <img
                                src={
                                  row?.profile_picture?.media_url ||
                                  "/static/images/user_placeholder.png"
                                }
                                alt=""
                              />
                            </figure>
                          </TableCell>
                          <TableCell>{row?.full_name || "-"}</TableCell>

                          <TableCell>
                            {row?.country_code + ` ` + row?.phone_no || "-"}
                          </TableCell>
                          <TableCell>{row?.email || "-"}</TableCell>
                          <TableCell>{row?.business_name || "-"}</TableCell>

                          <TableCell>
                            {row?.industry_type === 1
                              ? "RETAILER"
                              : row?.industry_type === 2
                                ? "WHOLESALER"
                                : row?.industry_type === 3
                                  ? "DISTRIBUTER"
                                  : ""}
                          </TableCell>
                          <TableCell>
                            {row?.address?.business_address || "-"}
                          </TableCell>

                          <TableCell>
                            <Box className="table_actions">
                              <IconButton
                                onClick={() =>
                                  navigate(
                                    `/manage-vendors/details/${row?.id}`,
                                    { state: { value } }
                                  )
                                }
                              >
                                <VisibilityIcon />
                              </IconButton>
                              <IconButton
                                onClick={() =>
                                  navigate(`/manage-vendors/edit/${row?.id}`)
                                }
                              >
                                <ModeEditIcon />
                              </IconButton>
                              <IconButton
                                onClick={() => {
                                  setOpen(true);
                                  setSelectedId(row?.id);
                                }}
                              >
                                <DeleteIcon />
                              </IconButton>
                            </Box>
                          </TableCell>
                        </TableRow>
                      ))
                    )}
                  </TableBody>
                </Table>
              </TableContainer>

              <WarnModal
                open={open}
                setOpen={setOpen}
                handleDelete={() => handleDeleteUser(selectedId)}
                name="Vendor"
              />
            </CustomTabPanel>
          </Box>
        </Card>
        {rows?.length > 0 ? (
          <Pagination
            setPage={setPage}
            module={rows}
            page={page}
            onPageChange={setPage}
            totalPages={totalPages}
            limit={limit}
            setLimit={setLimit}
            setTotalPages={setTotalPages}
            totalRecords={total_records}
          />
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default ManageAgents;
